<div class="main-scaling-wrapper">
  <div class="main-scaling-container">
    <main id="main" class="main-content">
      <!-- Dynamic content loaded here -->
    </main>
  </div>
</div>